// extracted by mini-css-extract-plugin
module.exports = {"blogs":"Blogs_blogs__IuYs9","addBlogs":"Blogs_addBlogs___ez5e"};